import axiosInstance from "./axios.instance";

// Send a notification
const API_SEND_NOTIFICATION = async (message) => {
  try {
    const resp = await axiosInstance.post("/admin/notifications", message);
    return resp.data;
  } catch (err) {
    console.error("Error sending notification:", err);
    throw err;
  }
};

// Get all notifications
const API_GET_NOTIFICATIONS = async () => {
  try {
    const resp = await axiosInstance.get("/admin/notifications");
    return resp.data;
  } catch (err) {
    console.error("Error fetching notifications:", err);
    throw err;
  }
};

// Create a new notification for a company
const API_CREATE_NOTIFICATION = async (notifications) => {
  try {
    const resp = await axiosInstance.post(
      "/admin/notifications/create",
      notifications
    );
    return resp.data;
  } catch (err) {
    console.error("Error creating notification:", err);
    throw err;
  }
};

// Update an existing notification
const API_UPDATE_NOTIFICATION = async (notificationId, notificationData) => {
  try {
    const payload = {
      ids: [notificationId],
      notification: notificationData,
    };
    const resp = await axiosInstance.post(
      "/admin/notifications/update",
      payload
    );
    return resp.data;
  } catch (err) {
    console.error("Error updating notification:", err);
    throw err;
  }
};

// Export all API functions
export {
  API_SEND_NOTIFICATION,
  API_GET_NOTIFICATIONS,
  API_CREATE_NOTIFICATION,
  API_UPDATE_NOTIFICATION,
};
